const fontSizes = {
    '2xl': '1.25em', // 20px - h2
    '3xl': '1.5em', // 24px - h1
    '4xl': '1.75em', // 28px - h1
    '5xl': '2em', // 32px
    '6xl': '3em', // 48px
    lg: '1em', // 16px - h3
    md: '0.875em', // 14px
    sm: '0.75em', // 12px
    xl: '1.125em', // 18px - h2
    xs: '0.625em', // 10px
};
export default fontSizes;
